const getters = {
  getAgentPortfolio(state) {
    return state.agentsPortfolio;
  },
};

export default getters;
